/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyStock } from 'app/shared/model/pharmacy-stock.model';
import { IPharmacyBill } from 'app/shared/model/pharmacy-bill.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';

export interface IPharmacyBillItem {
  id?: string;
  chargedMrp?: number;
  qty?: number;
  manufacDate?: number;
  expDate?: number;
  active?: boolean;
  cursor?: number;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  discount?: number | null;
  paidAmount?: number | null;
  taxCode?: string | null;
  cessAmount?: number | null;
  exempted?: boolean | null;
  freeQty?: number | null;
  pharmacyStock?: IPharmacyStock | null;
  pharmacyBill?: IPharmacyBill | null;
  uqcType?: IClinicalDictionary | null;
  scheme?: IPaymentScheme | null;
}

export const defaultValue: Readonly<IPharmacyBillItem> = {
  active: false,
  exempted: false,
};
